/* =========================================================
   EVERMORE — Appointment landing page (Shopify sections)
   One file, many sections. Each section is initialised on its
   own root, so sections can be added, removed, reordered or
   duplicated in the theme editor.
   ========================================================= */
(function () {
  if (window.EvaAppointment) return;             // loaded once even if every section includes it

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function onCleanup(root, fn) { (root.__evaCleanup = root.__evaCleanup || []).push(fn); }
  function cleanup(root) { (root.__evaCleanup || []).forEach(function (fn) { try { fn(); } catch (e) {} }); root.__evaCleanup = []; root.__evaReady = false; }
  function waUrl(num, text) { var n = String(num || '').replace(/[^\d]/g, ''); return 'https://wa.me/' + n + (text ? '?text=' + encodeURIComponent(text) : ''); }

  /* ---------------- HERO ---------------- */
  function initHero(root) {
    if (design) root.classList.add('eva-design-mode');

    // split headline into masked words
    var h = root.querySelector('.eva-split-words');
    if (h && !h.__split) {
      h.__split = true;
      var i = 0;
      (function wrap(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'eva-w';
              var inner = document.createElement('span'); inner.textContent = part;
              inner.style.transitionDelay = (0.55 + i++ * 0.07) + 's';
              w.appendChild(inner); frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1) { wrap(n); }
        });
      })(h);
    }

    // duplicate reel tracks once for a seamless loop
    $all('.eva-reel-stage .eva-track', root).forEach(function (tr) {
      if (tr.__dup) return; tr.__dup = true;
      Array.prototype.slice.call(tr.children).forEach(function (n) {
        var c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true');
        var im = c.querySelector('img'); if (im) im.alt = '';
        tr.appendChild(c);
      });
    });

    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('eva-go'); }); });

    var stage = root.querySelector('.eva-reel-stage');
    if (!stage) return;
    var cur = stage.querySelector('.eva-col.eva-b .eva-track'),
        spot = stage.querySelector('.eva-spot'),
        nameEl = stage.querySelector('.eva-spot-name');

    // curated centre column: one piece at a time into the spotlight
    if (cur && spot && cur.children.length >= 2) {
      var N = cur.children.length / 2, idx = 0, step = 0, base = 0, timer = null, t1 = null;
      var layout = function () {
        var first = cur.children[0]; if (!first) return;
        var gap = parseFloat(getComputedStyle(cur).rowGap) || 14;
        var hh = first.getBoundingClientRect().height, H = stage.clientHeight;
        step = hh + gap;
        base = Math.round(H / 2 - hh / 2 - 2 * step);
        spot.style.top = (H / 2 - hh / 2) + 'px'; spot.style.height = hh + 'px';
        cur.style.transition = 'none';
        cur.style.transform = 'translateY(' + (base - idx * step) + 'px)';
        cur.offsetHeight; cur.style.transition = '';
      };
      var nameAt = function (k) { var el = cur.children[k % cur.children.length]; return el ? el.getAttribute('data-name') || '' : ''; };
      var setName = function () {
        if (!nameEl) return;
        nameEl.classList.add('eva-swap');
        setTimeout(function () { nameEl.textContent = nameAt(idx + 2); nameEl.classList.remove('eva-swap'); }, 450);
      };
      var advance = function () {
        idx++;
        cur.style.transform = 'translateY(' + (base - idx * step) + 'px)';
        setName();
        setTimeout(function () {
          spot.classList.remove('eva-flash'); void spot.offsetWidth; spot.classList.add('eva-flash');
          if (idx >= N) { idx = 0; cur.style.transition = 'none'; cur.style.transform = 'translateY(' + base + 'px)'; cur.offsetHeight; cur.style.transition = ''; }
        }, 1650);
      };
      layout();
      if (nameEl) nameEl.textContent = nameAt(2);
      window.addEventListener('resize', layout);
      // images can change the first card height after load
      $all('img', cur).forEach(function (im) { if (!im.complete) im.addEventListener('load', layout, { once: true }); });
      var interval = parseFloat(stage.getAttribute('data-interval')) || 3600;
      if (!reduce) t1 = setTimeout(function () { spot.classList.add('eva-flash'); timer = setInterval(advance, interval); }, 2600);
      onCleanup(root, function () { clearTimeout(t1); clearInterval(timer); window.removeEventListener('resize', layout); });
    }

    // glints: four-point sparkles that bloom and fade
    var c = stage.querySelector('.eva-glints');
    if (c && c.getContext && !reduce) {
      var ctx = c.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), pts = [], raf = 0, alive = true;
      var size = function () { c.width = stage.clientWidth * dpr; c.height = stage.clientHeight * dpr; };
      var spawn = function () { return { x: .05 + Math.random() * .9, y: .18 + Math.random() * .64, r: 1.2 + Math.random() * 2.6, t: 0, life: 120 + Math.random() * 160 }; };
      size(); window.addEventListener('resize', size);
      for (var k = 0; k < 7; k++) { var p = spawn(); p.t = Math.random() * p.life; pts.push(p); }
      var star = function (x, y, r, a) {
        ctx.save(); ctx.translate(x, y); ctx.globalAlpha = a;
        var g = ctx.createRadialGradient(0, 0, 0, 0, 0, r * 2.2); g.addColorStop(0, 'rgba(255,248,230,.9)'); g.addColorStop(1, 'rgba(255,248,230,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(0, 0, r * 2.2, 0, Math.PI * 2); ctx.fill();
        ctx.fillStyle = 'rgba(255,250,240,.95)'; ctx.beginPath();
        ctx.moveTo(0, -r * 3); ctx.quadraticCurveTo(0, 0, r * 3, 0); ctx.quadraticCurveTo(0, 0, 0, r * 3); ctx.quadraticCurveTo(0, 0, -r * 3, 0); ctx.quadraticCurveTo(0, 0, 0, -r * 3); ctx.fill();
        ctx.restore();
      };
      var frame = function () {
        if (!alive) return;
        ctx.clearRect(0, 0, c.width, c.height);
        pts.forEach(function (p, i) {
          p.t++; var u = p.t / p.life, a = Math.sin(Math.PI * u); a = a * a;
          star(p.x * c.width, p.y * c.height, p.r * dpr * (.7 + .3 * a), a * .6);
          if (p.t >= p.life) pts[i] = spawn();
        });
        raf = requestAnimationFrame(frame);
      };
      raf = requestAnimationFrame(frame);
      onCleanup(root, function () { alive = false; cancelAnimationFrame(raf); window.removeEventListener('resize', size); });
    }

    // gentle scroll parallax
    if (!reduce && root.hasAttribute('data-parallax')) {
      var copy = root.querySelector('.eva-hero-copy'), ticking = false;
      var para = function () {
        var rect = root.getBoundingClientRect(), y = -rect.top, hh = root.offsetHeight;
        if (y > 0 && y < hh && window.innerWidth > 900) {
          if (copy) { copy.style.transform = 'translateY(' + (y * -0.12) + 'px)'; copy.style.opacity = String(Math.max(0, 1 - y / (hh * .75))); }
          stage.style.transform = 'translateY(' + (y * 0.08) + 'px)';
        } else if (y <= 0) {
          if (copy) { copy.style.transform = ''; copy.style.opacity = ''; }
          stage.style.transform = '';
        }
        ticking = false;
      };
      var onS = function () { if (!ticking) { ticking = true; requestAnimationFrame(para); } };
      window.addEventListener('scroll', onS, { passive: true });
      onCleanup(root, function () { window.removeEventListener('scroll', onS); });
    }
  }

  /* ---------------- STORIES (inline video) ---------------- */
  function initStories(root) {
    var stories = $all('.eva-story', root);
    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    function vidOf(s) { return s.querySelector('video'); }
    function load(v) { if (v && !v.getAttribute('src') && v.getAttribute('data-src')) v.src = v.getAttribute('data-src'); }
    function silenceOthers(keep) {
      $all('.eva-story').forEach(function (s) { if (s !== keep) { var v = vidOf(s); if (v) v.muted = true; s.classList.remove('eva-sound'); } });
    }
    function soundOn(s, v) { silenceOthers(s); load(v); v.muted = false; s.classList.add('eva-sound'); if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
    stories.forEach(function (s) {
      var v = vidOf(s), bar = s.querySelector('.eva-s-bar i'), media = s.querySelector('.eva-story-media');
      if (!v || !media) return;
      v.addEventListener('play', function () { s.classList.add('eva-playing'); });
      v.addEventListener('pause', function () { s.classList.remove('eva-playing'); });
      v.addEventListener('timeupdate', function () { if (v.duration && bar) bar.style.width = (v.currentTime / v.duration * 100) + '%'; });
      media.addEventListener('click', function (e) {
        if (e.target.closest('.eva-s-mute')) return;
        if (v.muted || v.paused) soundOn(s, v); else v.pause();
      });
      media.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); media.click(); } });
      var mute = s.querySelector('.eva-s-mute');
      if (mute) mute.addEventListener('click', function () {
        if (v.muted) soundOn(s, v); else { v.muted = true; s.classList.remove('eva-sound'); }
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var s = en.target, v = vidOf(s); if (!v) return;
          if (en.isIntersecting) {
            load(v);
            if (autoplay && !reduce && v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          } else if (!v.paused) { v.pause(); v.muted = true; s.classList.remove('eva-sound'); }
        });
      }, { threshold: .45 });
      stories.forEach(function (s) { io.observe(s); });
      onCleanup(root, function () { io.disconnect(); });
    } else { stories.forEach(function (s) { load(vidOf(s)); }); }
  }

  /* ---------------- MUSEUM (film modal) ---------------- */
  function initMuseum(root) {
    var btn = root.querySelector('.eva-play'), modal = root.querySelector('.eva-modal');
    if (!btn) return;
    var vid = modal && modal.querySelector('video');
    var src = btn.getAttribute('data-video'), fallback = btn.getAttribute('data-fallback');
    function close() { if (vid) vid.pause(); if (modal) modal.classList.remove('eva-open'); document.documentElement.style.overflow = ''; btn.focus(); }
    btn.addEventListener('click', function () {
      if (!src || !modal || !vid) { if (fallback) window.open(fallback, '_blank', 'noopener'); return; }
      if (vid.getAttribute('src') !== src) vid.src = src;
      modal.classList.add('eva-open'); document.documentElement.style.overflow = 'hidden';
      var p = vid.play(); if (p && p.catch) p.catch(function () {});
      var x = modal.querySelector('.eva-x'); if (x) x.focus();
    });
    if (modal) {
      modal.querySelector('.eva-x').addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      var onKey = function (e) { if (e.key === 'Escape' && modal.classList.contains('eva-open')) close(); };
      document.addEventListener('keydown', onKey);
      onCleanup(root, function () { document.removeEventListener('keydown', onKey); document.documentElement.style.overflow = ''; });
    }
  }

  /* ---------------- BOOKING FORM ---------------- */
  function initBooking(root) {
    var form = root.querySelector('form.eva-form');
    var wa = root.getAttribute('data-wa'), mode = root.getAttribute('data-mode') || 'both';
    var doneWa = root.querySelector('.eva-done-wa');

    // returning from a Shopify contact post: reuse the stored WhatsApp link
    if (root.classList.contains('eva-sent') && doneWa) {
      try { var stored = sessionStorage.getItem('eva_wa_url'); if (stored) doneWa.href = stored; } catch (e) {}
    }
    if (!form) return;

    var date = form.querySelector('[data-eva="date"]');
    if (date) { var d = new Date(); d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); date.min = d.toISOString().slice(0, 10); }

    // UTM capture
    try {
      var qs = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) {
        var el = form.querySelector('[data-eva="' + k + '"]'); if (el && qs.get(k)) el.value = qs.get(k);
      });
    } catch (e) {}

    function field(k) { return form.querySelector('[data-eva="' + k + '"]'); }
    function mark(k, bad) { var el = form.querySelector('[data-eva-wrap="' + k + '"]'); if (el) el.classList.toggle('eva-bad', bad); return !bad; }

    form.addEventListener('submit', function (e) {
      var ok = true;
      var shop = $all('input[data-eva="shop"]:checked', form).map(function (c) { return c.value; });
      var needShop = !!form.querySelector('[data-eva-wrap="shop"]');
      var phoneRaw = field('phone') ? field('phone').value : '';
      var phone = phoneRaw.replace(/[^\d]/g, '');
      var email = field('email') ? field('email').value.trim() : '';
      var name = field('name') ? field('name').value.trim() : '';
      ok = mark('date', field('date') && !field('date').value) && ok;
      ok = mark('time', field('time') && !field('time').value) && ok;
      if (needShop) ok = mark('shop', shop.length === 0) && ok;
      ok = mark('name', name.length < 2) && ok;
      ok = mark('phone', phone.length < 7) && ok;
      ok = mark('email', !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) && ok;
      if (!ok) { e.preventDefault(); var first = form.querySelector('.eva-bad'); if (first) first.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return; }

      var typeEl = form.querySelector('input[data-eva="type"]:checked');
      var cc = field('cc') ? field('cc').value : '';
      var p = {
        type: typeEl ? typeEl.value : '', date: field('date') ? field('date').value : '',
        time: field('time') ? field('time').value : '', shopping: shop, name: name,
        whatsapp: (cc ? cc + ' ' : '') + phone, email: email
      };
      var tz = root.getAttribute('data-tz') || '';
      var msg = (root.getAttribute('data-msg-intro') || "Hi Evermore, I'd like to book an appointment.") + '\n\n' +
        'Appointment: ' + p.type + '\nDate: ' + p.date + '\nTime: ' + p.time + (tz ? ' (' + tz + ')' : '') + '\n' +
        (shop.length ? 'Shopping for: ' + shop.join(', ') + '\n' : '') +
        '\nName: ' + p.name + '\nWhatsApp: ' + p.whatsapp + '\nEmail: ' + p.email;

      // hidden fields that land in the Shopify contact email
      if (field('shop_joined')) field('shop_joined').value = shop.join(', ');
      if (field('phone_full')) field('phone_full').value = p.whatsapp;
      if (field('body')) field('body').value = msg;

      if (window.dataLayer) window.dataLayer.push({ event: 'appointment_request', appointment_type: p.type, categories: shop.join('|') });
      root.dispatchEvent(new CustomEvent('eva:booking', { bubbles: true, detail: p }));

      var url = waUrl(wa, msg);
      if (doneWa) doneWa.href = url;
      if (mode !== 'shopify') {
        try { sessionStorage.setItem('eva_wa_url', url); } catch (err) {}
        window.open(url, '_blank', 'noopener');
      }
      if (mode === 'whatsapp') {
        e.preventDefault();
        root.classList.add('eva-sent');
        root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
      // otherwise the native submit continues → Shopify contact form (keeps Shopify's own spam protection)
    });
    var clear = function (e) { var b = e.target.closest('.eva-bad'); if (b) b.classList.remove('eva-bad'); };
    form.addEventListener('input', clear);
    form.addEventListener('change', clear);
  }

  /* ---------------- MOBILE STICKY BAR ---------------- */
  function initMbar(root) {
    var after = (parseFloat(root.getAttribute('data-after')) || 70) / 100;
    var onS = function () {
      var y = window.scrollY || 0, inBook = false;
      $all('[data-eva-book]').forEach(function (b) { var r = b.getBoundingClientRect(); if (r.top < window.innerHeight * 0.8 && r.bottom > 0) inBook = true; });
      root.classList.toggle('eva-show', design || (y > window.innerHeight * after && !inBook));
    };
    window.addEventListener('scroll', onS, { passive: true }); onS();
    onCleanup(root, function () { window.removeEventListener('scroll', onS); });
  }

  /* ---------------- CTA → preselect appointment type ---------------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-eva-type]');
    if (!a) return;
    var t = a.getAttribute('data-eva-type');
    $all('[data-eva-book] input[data-eva="type"]').forEach(function (r) {
      if (r.getAttribute('data-type-key') === t) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });

  var map = { hero: initHero, stories: initStories, museum: initMuseum, booking: initBooking, mbar: initMbar };
  function init(scope) {
    $all('[data-eva-init]', scope).forEach(function (root) {
      if (root.__evaReady) return; root.__evaReady = true;
      var fn = map[root.getAttribute('data-eva-init')]; if (fn) fn(root);
    });
  }
  window.EvaAppointment = { init: init, waUrl: waUrl };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { $all('[data-eva-init]', e.target).forEach(cleanup); });
})();
